import React from 'react';
import { useDrag } from 'react-dnd';

const withCard = WrappedComponent => (props) => {
  const { question } = props;

  const [{ isDragging }, drag] = useDrag({
    item: { type: question.type, linkId: question.linkId },
    collect: monitor => ({
      isDragging: !!monitor.isDragging()
    })
  })

  return <div
    ref={drag}
    style={{
      cursor: 'move',
      opacity: isDragging ? 0.1 : 1
    }}
    className="card mb-2">
    <div className="card-body">
      <WrappedComponent {...props} />
    </div>
  </div>
}

export default withCard;